<div class="dialog-close">
    <i class="fas fa-times dialog-fas" [mat-dialog-close]="true"></i>
</div>
<div class="table-container-kpi" style="padding-top: 15px">
    <kendo-grid
        #grid
        [loading]="loading"
        [data]="gridData"
        [sortable]="sortable"
        [scrollable]="'scrollable'"
        [sort]="sort"
        (sortChange)="sortChange($event)"
        class="lg-kendo-grid"
        #kendoGrid="kendoGrid"
    >
        <kendo-grid-column
            field="clientKPIDescription"
            title="Key Performance Indicator"
            [width]="230"
        >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                {{ dataItem.clientKPIDescription }}

                <span style="color: red" *ngIf="isInvalid(dataItem)">
                    <p *ngFor="let error of dataItem.errors">{{ error }}</p>
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Start" [width]="90" field="startDate">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ getFriendlyDate(dataItem.startDate) }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Stop" [width]="90" field="stopDate">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ getFriendlyDate(dataItem.stopDate) }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
            field="range1End"
            title="Poor"
            [width]="85"
            [headerStyle]="{ 'background-color': '#fddbdb', 'text-align': 'center' }"
            [style]="{ 'background-color': '#fddbdb', padding: '10px 18px' }"
        >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <span style="padding-right: 2px">
                    <span *ngIf="dataItem.bestScore == 'Highest'" title="Less Than">&le;</span>
                    <span *ngIf="dataItem.bestScore == 'Lowest'" title="Greater Than">&ge;</span>
                </span>
                <span *ngIf="dataItem.isPercentage">{{ dataItem.range1End | number }}%</span>
                <span *ngIf="!dataItem.isPercentage">{{
                    dataItem.kpiFormat === 'currency'
                        ? (dataItem.range1End | currency: 'USD':'symbol':'1.0-0')
                        : (dataItem.range1End | number)
                }}</span>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
            field="range2Start"
            title="Fair"
            [width]="160"
            [headerStyle]="{ 'background-color': '#fff9e7', 'text-align': 'center' }"
            [style]="{ 'background-color': '#fff9e7', padding: '10px 18px' }"
        >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <div *ngIf="dataItem.canEdit">
                    <span>
                        <i
                            class="fas fa-exclamation-circle ng-star-inserted form-error"
                            *ngIf="dataItem.range2StartError"
                        ></i
                    ></span>
                    <mat-form-field appearance="outline" style="width: 90px; height: 55px">
                        <mat-label>Start</mat-label>
                        <input
                            matInput
                            [(ngModel)]="dataItem.range2Start"
                            type="number"
                            (change)="
                                rangeChange(
                                    dataItem,
                                    'range1End',
                                    'range2Start',
                                    'range2StartError',
                                    true
                                )
                            "
                            [ngClass]="{ 'form-error': dataItem.range2StartError }"
                        />
                    </mat-form-field>

                    <span style="padding-left: 9px; padding-right: 7px">-</span>
                    <span *ngIf="dataItem.isPercentage">{{ dataItem.range2End | number }}%</span>
                    <span *ngIf="!dataItem.isPercentage">{{
                        dataItem.kpiFormat === 'currency'
                            ? (dataItem.range2End | currency: 'USD':'symbol':'1.0-0')
                            : dataItem.range2End
                    }}</span>
                </div>
                <div *ngIf="!dataItem.canEdit" style="text-align: center">
                    <span *ngIf="!dataItem.isPercentage">{{
                        dataItem.kpiFormat === 'currency'
                            ? (dataItem.range2Start | currency: 'USD':'symbol':'1.0-0')
                            : dataItem.range2Start
                    }}</span>
                    <span style="padding-left: 9px; padding-right: 7px">-</span>
                    <span *ngIf="dataItem.isPercentage">{{ dataItem.range2End | number }}%</span>
                    <span *ngIf="!dataItem.isPercentage">{{
                        dataItem.kpiFormat === 'currency'
                            ? (dataItem.range2End | currency: 'USD':'symbol':'1.0-0')
                            : dataItem.range2End
                    }}</span>
                </div>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
            field="range3Start"
            title="Good"
            [width]="270"
            [headerStyle]="{ 'background-color': '#e0f3f3', 'text-align': 'center' }"
            [style]="{ 'background-color': '#e0f3f3', padding: '10px 18px' }"
        >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <div *ngIf="dataItem.canEdit">
                    <span>
                        <i
                            class="fas fa-exclamation-circle ng-star-inserted form-error"
                            *ngIf="dataItem.range3StartError || dataItem.range3EndError"
                        ></i>
                    </span>

                    <mat-form-field
                        appearance="outline"
                        style="width: 90px; height: 55px"
                        [ngClass]="{ 'form-error': dataItem.range3StartError }"
                    >
                        <mat-label>Start</mat-label>
                        <input
                            matInput
                            [(ngModel)]="dataItem.range3Start"
                            type="number"
                            (change)="
                                rangeChange(
                                    dataItem,
                                    'range2End',
                                    'range3Start',
                                    'range3StartError',
                                    true
                                )
                            "
                        />
                    </mat-form-field>

                    <span
                        style="
                            font-size: 16px;
                            padding-left: 10px;
                            padding-right: 8px;
                            text-align: center;
                        "
                    >
                        <span *ngIf="dataItem.bestScore == 'Highest'" title="Less Than">&lt;</span>
                        <span *ngIf="dataItem.bestScore == 'Lowest'" title="Greater Than"
                            >&gt;</span
                        >
                    </span>
                    <span *ngIf="dataItem.isPercentage">{{ dataItem.target | number }}%</span>
                    <mat-form-field appearance="outline" style="width: 80px; height: 55px">
                        <mat-label>Target</mat-label>
                        <input
                            matInput
                            [(ngModel)]="dataItem.target"
                            [ngClass]="{ 'form-error': dataItem.targetError }"
                            type="number"
                            [readonly]="!dataItem.canEdit"
                        />
                        <!-- <span *ngIf="!dataItem.canEdit">{{ dataItem.target }}</span> -->
                    </mat-form-field>

                    <span
                        style="
                            font-size: 16px;
                            padding-left: 8px;
                            padding-right: 10px;
                            text-align: center;
                        "
                    >
                        <span *ngIf="dataItem.bestScore == 'Highest'" title="Less Than">&lt;</span>
                        <span *ngIf="dataItem.bestScore == 'Lowest'" title="Greater Than"
                            >&gt;</span
                        >
                    </span>
                    <mat-form-field
                        appearance="outline"
                        style="width: 90px; height: 55px"
                        [ngClass]="{ 'form-error': dataItem.range3EndError }"
                    >
                        <mat-label>End</mat-label>
                        <input
                            matInput
                            [(ngModel)]="dataItem.range3End"
                            type="number"
                            (change)="
                                rangeChange(
                                    dataItem,
                                    'range4Start',
                                    'range3End',
                                    'range3EndError',
                                    false
                                )
                            "
                        />
                    </mat-form-field>
                </div>
                <div *ngIf="!dataItem.canEdit" style="text-align: center">
                    <span *ngIf="!dataItem.isPercentage">{{
                        dataItem.kpiFormat === 'currency'
                            ? (dataItem.range3Start | currency: 'USD':'symbol':'1.0-0')
                            : dataItem.range3Start
                    }}</span>
                    <span style="padding-left: 9px; padding-right: 7px">-</span>
                    <span *ngIf="dataItem.isPercentage">{{ dataItem.range3End | number }}%</span>
                    <span *ngIf="!dataItem.isPercentage">{{
                        dataItem.kpiFormat === 'currency'
                            ? (dataItem.range3End | currency: 'USD':'symbol':'1.0-0')
                            : dataItem.range3End
                    }}</span>
                </div>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
            field="range4Start"
            title="Very Good"
            [width]="150"
            [headerStyle]="{ 'background-color': '#f7efff', 'text-align': 'center' }"
            [style]="{ 'background-color': '#f7efff', padding: '10px 18px' }"
        >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <div *ngIf="dataItem.canEdit">
                    <span>
                        <i
                            class="fas fa-exclamation-circle ng-star-inserted form-error"
                            *ngIf="dataItem.range4EndError"
                        ></i
                    ></span>
                    <span *ngIf="dataItem.isPercentage">{{ dataItem.range4Start | number }}%</span>
                    <span *ngIf="!dataItem.isPercentage">{{
                        dataItem.kpiFormat === 'currency'
                            ? (dataItem.range4Start | currency: 'USD':'symbol':'1.0-0')
                            : dataItem.range4Start
                    }}</span>
                    <span style="padding-left: 7px; padding-right: 9px">-</span>

                    <mat-form-field appearance="outline" style="width: 90px; height: 55px">
                        <mat-label>End</mat-label>
                        <input
                            matInput
                            [(ngModel)]="dataItem.range4End"
                            type="number"
                            (change)="
                                rangeChange(
                                    dataItem,
                                    'range5Start',
                                    'range4End',
                                    'range4EndError',
                                    false
                                )
                            "
                        />
                    </mat-form-field>
                </div>
                <div *ngIf="!dataItem.canEdit" style="text-align: center">
                    <span *ngIf="!dataItem.isPercentage">{{
                        dataItem.kpiFormat === 'currency'
                            ? (dataItem.range4Start | currency: 'USD':'symbol':'1.0-0')
                            : dataItem.range4Start
                    }}</span>
                    <span style="padding-left: 9px; padding-right: 7px">-</span>
                    <span *ngIf="dataItem.isPercentage">{{ dataItem.range4End | number }}%</span>
                    <span *ngIf="!dataItem.isPercentage">{{
                        dataItem.kpiFormat === 'currency'
                            ? (dataItem.range4End | currency: 'USD':'symbol':'1.0-0')
                            : dataItem.range4End
                    }}</span>
                </div>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
            field="range5Start"
            title="Excellent"
            [width]="90"
            [headerStyle]="{ 'background-color': '#f3f9ed', 'text-align': 'center' }"
            [style]="{ 'background-color': '#f3f9ed', padding: '10px 18px' }"
        >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <span style="padding-right: 4px">
                    <span *ngIf="dataItem.bestScore == 'Lowest'" title="Less Than">&le;</span>
                    <span *ngIf="dataItem.bestScore == 'Highest'" title="Greater Than">&ge;</span>
                </span>
                <span *ngIf="dataItem.isPercentage">{{ dataItem.range5Start | number }}%</span>
                <span *ngIf="!dataItem.isPercentage">{{
                    dataItem.kpiFormat === 'currency'
                        ? (dataItem.range5Start | currency: 'USD':'symbol':'1.0-0')
                        : dataItem.range5Start
                }}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="75" title="Delete" [style]="{ 'text-align': 'center' }">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <i
                    class="fa fa-trash delete-button"
                    (click)="delete(dataItem)"
                    style="font-size: 23px"
                    *ngIf="dataItem.canDelete"
                ></i>
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>
</div>
<div class="dialog-content-container">
    <div class="dialog-content">
        <div class="dialog-content-text">
            Choose a start date for the new version. The new target and ranges will be affected on
            the first day of the month chosen.
        </div>
        <div class="dialog-content-interaction">
            <div class="interaction-description">New Version Start Date:</div>
            <mat-select class="custom-select-outline-color month-select" [(ngModel)]="selectedDate">
                <mat-option *ngFor="let day of sixMonthDates" [value]="day.date">
                    {{ day.friendlyDate }}
                </mat-option>
            </mat-select>
        </div>
        <div class="dialog-buttons">
            <mat-button-toggle
                value="bold"
                (click)="add()"
                class="save-button"
                [disabled]="!canAddNewVersion"
                >ADD NEW VERSION</mat-button-toggle
            >
            <mat-button-toggle value="bold" (click)="saveEdit()" class="save-button"
                >SAVE</mat-button-toggle
            >
        </div>
    </div>
</div>
